import { NewLayout } from "./NewLayout";

export default NewLayout;
